import type { Indexation } from '@features/partners/builder/settings/platform-access/indexation/indexation.component';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';

export class IndexationWebservice {
  readonly #http = inject(HttpClient);
  readonly baseUrl = environment.api.obendy;

  get(partnerId: string): Observable<Indexation> {
    return this.#http.get<Indexation>(`${this.baseUrl}/v1/partner-revision/${partnerId}/seo`);
  }

  patch(partnerId: string, indexation: Indexation): Observable<Indexation> {
    return this.#http.patch<Indexation>(`${this.baseUrl}/v1/partner-revision/${partnerId}/seo`, indexation);
  }
}
